import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const difficultyLevelDeleteApi = createAsyncThunk(
    'auth/difficulty-level/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.difficultyLevelAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const difficultyLevelDeleteSlice = createSlice({
    name: 'difficulty-level delete',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(difficultyLevelDeleteApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(difficultyLevelDeleteApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(difficultyLevelDeleteApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const difficultyLevelDeleteReducer = difficultyLevelDeleteSlice.reducer